import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

export const notificationsKey = (params?: Record<string, unknown>) =>
  ['marketplace', 'notifications', params] as const;

export function useNotifications(params?: { unread_only?: boolean; page?: number; per_page?: number }) {
  return useQuery({
    queryKey: notificationsKey(params),
    queryFn: () => marketplaceService.listNotifications(params),
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => marketplaceService.markAllNotificationsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['marketplace', 'notifications'] });
    },
  });
}
